export default "__VITE_ASSET__DEg6i_SM__"